<template>
  <div class="flex-box-center-items-vertical">
    <!-- poll section 4 (new layout only) -->
    <PollSectionHeader
      v-if="sections"
      :number="4"
      :title="sections.submit.title"
      :text="sections.submit.text"
      :done="isPollPlzValid()"
    ></PollSectionHeader>
    <div
      class="flex-box-right-aligned-horizontal"
      style="align-items: flex-end"
    >
      <label for="poll-plz-input" style="margin-right: 5px">{{
        sections
          ? "Postleitzahl Ihres Wohnorts (5 Ziffern)"
          : "Bitte geben Sie ihre Postleitzahl an"
      }}</label>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }"
          ><v-icon
            :color="$vuetify.theme.themes.light.secondary"
            size="dense"
            dark
            v-bind="attrs"
            v-on="on"
            >mdi-help-circle</v-icon
          ></template
        >
        <span>
          Die Daten werden anonym gespeichert. Es wird nur die PLZ übermittelt,
          nicht die vollständige Adresse. Es ist anhand der Angaben kein
          Rückschluss auf Sie als Person möglich.
        </span>
      </v-tooltip>
      <input
        id="poll-plz-input"
        :value="pollPlz() === '0' && sections ? '' : pollPlz()"
        @change="pollPlzChanged"
        inputmode="numeric"
        maxlength="5"
        placeholder="z.B. 28195"
        aria-describedby="poll-missing-items"
        :style="colorOfInputElementsStyle"
        style="
          margin-left: 10px;
          margin-right: 10px;
          padding-left: 5px;
          width: 100px;
        "
      />
    </div>
    <!-- checklist explaining why "Weiter" is still disabled (new layout) -->
    <div
      v-if="sections"
      id="poll-missing-items"
      class="poll-footer__checklist"
    >
      <PollProgress></PollProgress>
    </div>
    <v-btn
      style="width: fit-content; align-self: end"
      :disabled="!isPollValid || isSubmitted"
      :color="isPollValid && !isSubmitted ? 'primary' : ''"
      :dark="isPollValid && !isSubmitted"
      @click="submitPoll()"
    >
      {{ submitButtonText }}</v-btn
    >
    <span
      v-if="
        useExternalPollLink && externalPollLink && isPollValid && isSubmitted
      "
      style="color: red; align-self: end"
      >Hier klicken, falls kein Link geöffnet wurde:
      <a target="_blank" :href="externalPollLink">{{
        externalPollLink
      }}</a></span
    >
    <!-- legacy layout keeps the single-line error messages -->
    <template v-if="!sections">
      <span v-if="!isPollPlzValid()" style="color: red; align-self: end"
        >Postleitzahl ungültig!</span
      >
      <span v-if="!isFrequenciesValid()" style="color: red; align-self: end"
        >Gesamthäufigkeit der Transportvarianten ungültig!</span
      >
      <span v-if="!isStarsValid()" style="color: red; align-self: end"
        >Bitte bewerten Sie alle Varianten mit Sternen!</span
      >
      <span v-if="!isTransportsUsedValid()" style="color: red; align-self: end"
        >Bitte wählen Sie genau eine Option aus der obenstehenden Liste aus!</span
      >
    </template>

    <span
      :style="{
        color:
          isSubmitted && submitText
            ? $vuetify.theme.themes.light.secondary
            : submitText
            ? 'red'
            : '',
      }"
      v-if="submitText"
      >{{ submitText }}</span
    >
    <v-btn
      v-if="useAlternativeExternalPollLink === true"
      style="width: fit-content; align-self: end; white-space: pre-wrap"
      :disabled="!isAlternativePollValid || isSubmitted"
      @click="submitAlternativePoll()"
    >
      {{ alternativeSubmitButtonText }}</v-btn
    >
     <span
      v-if="
        useAlternativeExternalPollLink && alternativeExternalPollLink && isAlternativePollValid && isSubmittedAlternativePoll
      "
      style="color: red; align-self: end"
      >Hier klicken, falls kein Link geöffnet wurde:
      <a target="_blank" :href="alternativeExternalPollLink">{{
        alternativeExternalPollLink
      }}</a></span
    >
     <span
      :style="{
        color:
          isSubmittedAlternativePoll && submitTextAlternativePoll
            ? $vuetify.theme.themes.light.secondary
            : submitTextAlternativePoll
            ? 'red'
            : '',
      }"
      v-if="submitTextAlternativePoll"
      >{{ submitTextAlternativePoll }}</span
    >
  </div>
</template>
<script>
import { storeToRefs } from "pinia";
import Vue from "vue";
import { savePollToDB } from "../../api";
import { Poll } from "../../cr-api-client/src";
import { usePollStore } from "../../store/poll-store";
import * as utils from "../../utils";
import PollSectionHeader from "./PollSectionHeader.vue";
import PollProgress from "./PollProgress.vue";

export default Vue.extend({
  name: "PollFooter",
  components: { PollSectionHeader, PollProgress },
  props: {
    routes: { type: Array, default: () => [] },
    destination: { type: String, default: "" },
  },

  data: () => ({
    isSubmitted: false,
    isSubmittedAlternativePoll: false,
    submitText: "",
    submitTextAlternativePoll: "",
    pollValid: false,
    externalPollLink: undefined,
    alternativeExternalPollLink: undefined,
  }),

  mounted() {
    // if (this.useExternalPollLink && this.externalPollLink) {
    //   const pollType = storeToRefs(usePollStore()).pollType.value;
    //   const pollDate = storeToRefs(usePollStore()).pollDate.value;
    //   const clientName = storeToRefs(usePollStore()).clientName.value;
    //   fetchUserPollId(clientName, pollDate, pollType)
    //     .then((res) => {
    //       this.pollUserId = res;
    //     })
    //     .catch((err) => console.log("Error while fetching user-id: ", err));
    // }
  },

  methods: {
    pollPlz() {
      const store = usePollStore();
      return storeToRefs(store).pollPlz.value;
    },
    isPollPlzValid() {
      return usePollStore().isPollPlzValid();
    },
    isFrequenciesValid() {
      return usePollStore().isPollFrequenciesValid();
    },
    isTransportsUsedValid() {
      return usePollStore().isTransportsUsedValid();
    },
    isStarsValid() {
      return usePollStore().isPollStarsValid();
    },
    pollPlzChanged(event) {
      const plzStr = String(event.target.value || "").trim();
      usePollStore().setPlz(plzStr);
      // this.updatePollPlz(plzStr);
    },
    parseGeneralPollData() {
      const numOrZeroFunc = (v) => (!Number.isNaN(Number(v)) ? Number(v) : 0);
      const poll = {
        pollType: storeToRefs(usePollStore()).pollType.value,
        plz: storeToRefs(usePollStore()).pollPlz.value,
        pollDate: storeToRefs(usePollStore()).pollDate.value,
        destination: this.destination,
        clientName: storeToRefs(usePollStore()).clientName.value,
        employeeId: -1,
        monthsInOrg: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsInOrganization.value
        ),
        monthsInOrgMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsInOrganizationMax.value
        ),
        workdaysPerWeek: numOrZeroFunc(
          storeToRefs(usePollStore()).pollWorkingDays.value
        ),
        workdaysPerWeekMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollWorkingDaysMax.value
        ),
        homeofficeDaysPerWeek: numOrZeroFunc(
          storeToRefs(usePollStore()).pollHomeofficeDays.value
        ),
        homeofficeDaysPerWeekMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollHomeofficeDaysMax.value
        ),
        monthsInUniversity: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsInUniversity.value
        ),
        monthsInUniversityMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsInUniversityMax.value
        ),
        monthsLecturePeriod: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsLecturePeriod.value
        ),
        monthsLecturePeriodMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsLecturePeriodMax.value
        ),
        monthsLectureFreePeriod: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsLectureFreePeriod.value
        ),
        monthsLecturePeriodMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsLecturePeriodMax.value
        ),
        presenceDaysInLecturePeriod: numOrZeroFunc(
          storeToRefs(usePollStore()).pollPresenceDaysInLecturePeriod.value
        ),
        presenceDaysInLecturePeriodMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollPresenceDaysInLecturePeriodMax.value
        ),
        monthsLectureFreePeriodMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollMonthsLectureFreePeriodMax.value
        ),
        presenceDaysInLectureFreePeriod: numOrZeroFunc(
          storeToRefs(usePollStore()).pollPresenceDaysInLectureFreePeriod.value
        ),
        presenceDaysInLectureFreePeriodMax: numOrZeroFunc(
          storeToRefs(usePollStore()).pollPresenceDaysInLectureFreePeriodMax
        ),
      };
      return poll;
    },
    async submitAlternativePoll() {
      let poll = this.parseGeneralPollData();

      let poll_obj = Poll.constructFromObject(poll);
      let res;
      try {
        res = await savePollToDB(poll_obj);
      } catch (e) {
        this.submitTextAlternativePoll =
          "Leider ist ein Fehler bei der Übertragung aufgetreten.\n Bitte versuchen Sie es später erneut.";
      }
      if (res?.status) {
        // if there is an external poll link provided and
        if (!this.useAlternativeExternalPollLink || !res.data?.userPollId) {
          this.submitTextAlternativePoll =
            "Vielen Dank für Ihre Teilnahme! Die Daten wurden erfolgreich gespeichert.";
        }
        this.isSubmittedAlternativePoll = true;
      } else if (!this.submitTextAlternativePoll) {
        this.submitTextAlternativePoll =
          "Leider ist ein Fehler bei der Übertragung aufgetreten.\n Bitte versuchen Sie es später erneut.";
      }
      if (this.useAlternativeExternalPollLink && res?.data?.userPollId) {
        let pollLink = storeToRefs(usePollStore()).alternativeExternalPollLink.value;
        if (res?.data?.userPollId) {
          pollLink += "?r=" + res.data?.userPollId;
        }
        this.alternativeExternalPollLink = pollLink;
      }

      // usePollStore().resetSuveyInput();
      // if external poll link is desired to be shown and it exists, then open it in new tab
      if (this.useAlternativeExternalPollLink && this.alternativeExternalPollLink) {
        window.open(this.alternativeExternalPollLink, "_blank");
      }

    },
    async submitPoll() {
      let routesPoll = this.routes.map((route, i) => ({
        ...route,
        frequency: usePollStore().pollFrequency(route.transport.id),
        nPassengers: usePollStore().numberPassengersOfTransport(
          route.transport.id
        ),
        transportUsed: usePollStore().isTransportUsed(route.transport.id),
        nStars: usePollStore().getNumberStars(route.transport.id),
      }));

      let poll = this.parseGeneralPollData();
      poll["routes"] = routesPoll;

      let poll_obj = Poll.constructFromObject(poll);
      let res;
      try {
        res = await savePollToDB(poll_obj);
      } catch (e) {
        this.submitText =
          "Leider ist ein Fehler bei der Übertragung aufgetreten.\n Bitte versuchen Sie es später erneut.";
      }
      if (res?.status) {
        // if there is an external poll link provided and
        if (!this.useExternalPollLink || !res.data?.userPollId) {
          this.submitText =
            "Vielen Dank für Ihre Teilnahme! Die Daten wurden erfolgreich gespeichert.";
        }
        this.isSubmitted = true;
      } else if (!this.submitText) {
        this.submitText =
          "Leider ist ein Fehler bei der Übertragung aufgetreten.\n Bitte versuchen Sie es später erneut.";
      }
      if (this.useExternalPollLink && res?.data?.userPollId) {
        let pollLink = storeToRefs(usePollStore()).externalPollLink.value;
        if (res?.data?.userPollId) {
          pollLink += "?r=" + res.data?.userPollId;
        }
        this.externalPollLink = pollLink;
      }

      // usePollStore().resetSuveyInput();
      // if external poll link is desired to be shown and it exists, then open it in new tab
      if (this.useExternalPollLink && this.externalPollLink) {
        window.open(this.externalPollLink, "_blank");
      }

      // console.log("mySavedPolls=", res);
    },
    // connectToApi(poll) {
    //   var defaultClient = ApiClient.instance;

    //   // Configure API key authorization: apiKey
    //   var apiKey = defaultClient.authentications["apiKey"];
    //   apiKey.apiKey = "abc12341";
    //   // Uncomment the following line to set a prefix for the API key, e.g. "Token" (defaults to null)
    //   //apiKey.apiKeyPrefix['apiKey'] = "Token"
    //   const pollApi = new PollApi(defaultClient);
    //   const aApi = new AdressesApi(defaultClient);
    //   aApi.postAdress({street: "test-street"});

    //   // pollApi
    //   //   .writePoll({body: {}})
    //   //   .then((res) => console.log("Response=", res))
    //   //   .catch((err) => console.log("Error: ", err));

    //   // var callback = function(error, data, response) {
    //   //   if (error) {
    //   //     console.error(error);
    //   //   } else {
    //   //     console.log('API called successfully. Returned data: ' + data);
    //   //   }
    //   // };
    //   // api.deleteAdress(adId, callback);
    // },
  },

  computed: {
    alternativeSubmitButtonText() {
          return "Bei Bedarf: Weiter zur alternativen Eingabe \n Ihrer Verkehrsmittelkombination ";
    },
    submitButtonText() {
      let pollLink = storeToRefs(usePollStore()).externalPollLink.value;
      return this.useExternalPollLink && pollLink
        ? "Weiter zur nächsten Frage"
        : "absenden";
    },
    useExternalPollLink() {
      return storeToRefs(usePollStore()).useExternalPollLink.value;
    },
    useAlternativeExternalPollLink() {
      return storeToRefs(usePollStore()).useAlternativeExternalPollLink.value;
    },
    // externalPollLink() {
    //   let pollLink = storeToRefs(usePollStore()).externalPollLink.value;
    //   if (this.userPollId) {
    //     pollLink += "?userPollId=" + this.userPollId;
    //   }
    //   return pollLink;
    // },
    isPollValid() {
      return usePollStore().isPollValid(); //isPollPlzValid();
    },
    sections() {
      const sections = storeToRefs(usePollStore()).sections.value;
      return sections ? { submit: {}, ...sections } : undefined;
    },
    isAlternativePollValid() {
      return usePollStore().isAlternativePollValid(); //isPollPlzValid();
    },
    colorOfInputElementsStyle() {
      return utils.colorOfInputElementsStyle.bind(this)();
    },
  },

  watch: {},
});
</script>

<style scoped>
.full-width {
  width: 100%;
}
.poll-footer__checklist {
  align-self: end;
  max-width: 700px;
  margin: 10px 0;
}
.sort-btns >>> button:not(.v-btn--active),
.sort-btns >>> i,
button {
  color: #333 !important;
}
.background-white {
  background-color: white;
}
.padding-10px {
  padding: 10px;
}
.border-radius-10px {
  border-radius: 10px;
}
.flex-box-centered-horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.cursor-pointer {
  cursor: pointer;
}
.font-size-22px {
  font-size: 22px;
}
.margin-left-15px {
  margin-left: 15px;
}
</style>
